$(function()
{
    var viewportMobileMaxWidth = 767;
    var viewportInitialWidth = $(window).width();
    var initialLayoutMode = getLayoutMode(viewportInitialWidth);

    function loadScript(currentLayoutMode)
    {
        if (currentLayoutMode == 'desktop')
        {
            $.getScript('/assets/javascript/desktop.min.js');
        }
        else
        {
            $.getScript('/assets/javascript/mobile.min.js');
        }
    }

    function getLayoutMode(currentViewportWidth)
    {
        if (currentViewportWidth > viewportMobileMaxWidth)
        {
            return 'desktop';
        }
        else
        {
            return 'mobile';
        }
    }

    function onViewportResize()
    {
        var viewportWidth = $(window).width();
        var currentLayoutMode = getLayoutMode(viewportWidth);

        if (currentLayoutMode != initialLayoutMode)
        {
            // window.location.href = window.location.href;
            initialLayoutMode = currentLayoutMode;
        }
    }

    loadScript(initialLayoutMode);
    $(window).resize(onViewportResize);
});
